import React from "react";

function HomeIcon2() {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="navIcon fillNone"
    >
      <path
        d="M31.904 13.157h0L17.258.984h0a.977.977 0 00-1.268 0L1.345 13.157h0c-.461.383-.55 1.096-.224 1.602.337.523 1.01.653 1.492.253h0L16.624 3.366l14.012 11.646c.187.156.409.234.633.234.337 0 .658-.176.858-.487.327-.506.237-1.219-.223-1.602z"
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
      />
      <path
        className="noFill"
        d="M7.204 16.825V30.39h18.84"
        stroke="#fff"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="noFill"
        d="M26.044 16.825V30.39H7.929"
        stroke="#fff"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HomeIcon2;
